<template>
  <div class="login-wrapper">
    <!-- Background -->
    <div class="bg-image"></div>
    <div class="bg-overlay"></div>

    <b-container fluid class="h-100">
      <b-row class="h-100 no-gutters">
        <!-- LEFT SIDE — LOGO + TEXT -->
        <b-col
          cols="12"
          lg="6"
          class="d-flex flex-column justify-content-center text-left px-5pc left-info"
        >
          <div class="left-content">
            <img src="~@/assets/img/brand/logo_abitue_white.png" />

            <h1 class="slide-title text-white mt-5">
              O futuro do seu restaurante começa aqui
            </h1>

            <p class="slide-text text-white">
              Compreenda comportamentos, crie campanhas, controle gastos e faça
              cross sell entre os seus restaurantes num só sítio.
            </p>
          </div>
        </b-col>

        <!-- RIGHT SIDE — LOGIN CARD -->
        <b-col
          cols="12"
          lg="6"
          class="d-flex align-items-center justify-content-center right-side"
        >
          <div class="login-card shadow-lg p-5">
            <!-- TITULO DINÂMICO -->
            <template v-if="!forgotMode">
              <p class="font-weight-bold small mb-1">BEM-VINDO DE VOLTA</p>
              <h2 class="font-weight-bold mb-4">Entre na sua conta</h2>
            </template>

            <template v-else>
              <p class="font-weight-bold small mb-1">RECUPERAR ACESSO</p>
              <h2 class="font-weight-bold mb-4">Escreva o seu email</h2>
            </template>

            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <!-- FORM LOGIN -->
              <b-form
                v-if="!forgotMode"
                @submit.prevent="handleSubmit(onSubmit)"
              >
                <base-input
                  alternative
                  class="mb-3"
                  name="Email"
                  :rules="{ required: true }"
                  prepend-icon="ni ni-email-83"
                  placeholder="Email"
                  v-model="model.username"
                />

                <base-input
                  alternative
                  class="mb-2"
                  name="Password"
                  :rules="{ required: true, min: 6 }"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Password"
                  v-model="model.password"
                />

                <p class="error">{{ error }}</p>

                <div
                  class="d-flex justify-content-between align-items-center mb-3"
                >
                  <a class="forgot-link pointer" @click="forgotMode = true">
                    Esqueci-me da password
                  </a>
                </div>

                <base-button
                  type="primary"
                  native-type="submit"
                  class="btn-login"
                >
                  Entrar
                </base-button>
              </b-form>

              <!-- FORM FORGOT PASSWORD -->
              <b-form v-else @submit.prevent="handleSubmit(onSubmitForgot)">
                <base-input
                  alternative
                  class="mb-3"
                  name="forgotEmail"
                  :rules="{ required: true }"
                  prepend-icon="ni ni-email-83"
                  placeholder="Insira o seu email"
                  v-model="model.forgotEmail"
                />

                <p class="error">{{ error }}</p>

                <base-button
                  type="primary"
                  native-type="submit"
                  class="btn-login"
                >
                  Continuar
                </base-button>

                <div class="text-center mt-3">
                  <a class="forgot-link pointer" @click="forgotMode = false">
                    Voltar ao login
                  </a>
                </div>
              </b-form>
            </validation-observer>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import api from "@/api";

  export default {
    data() {
      return {
        error: "",
        forgotMode: false,
        model: {
          username: "",
          password: "",
          forgotEmail: "",
        },
      };
    },

    methods: {
      async onSubmitForgot() {
        this.error = "";
        try {
          await api.post("/auth/request-reset", {
            email: this.model.forgotEmail,
          });
        } catch {
          // Nunca revelar se o email existe — tratar erro igual ao sucesso
        }
        this.$notify({
          type: "success",
          title: "Email enviado",
          message:
            "Se este email existir na nossa base de dados, receberá um link de recuperação.",
        });
        this.forgotMode = false;
      },

      async onSubmit() {
        this.error = "";
        try {
          const { data } = await api.post("/auth/login", {
            email: this.model.username,
            password: this.model.password,
          });

          localStorage.setItem("tokenAbitue", data.token);
          localStorage.setItem("user", JSON.stringify(data.user));
          this.$router.push("/dashboard");
        } catch (err) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message:
              err.response?.data?.error ||
              "Erro ao iniciar sessão. Verifica as credenciais.",
          });
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .login-wrapper {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }
  .px-5pc {
    padding-left: 10% !important;
    padding-right: 10% !important;
  }
  .bg-image {
    position: absolute;
    inset: 0;
    background-image: url("~@/assets/img/auth/login-bg.png") !important;
    background-size: cover;
    background-position: center;
    z-index: 1;
    opacity: 0.7;
  }
  .bg-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(2px);
    z-index: 2;
  }
  p.error {
    color: red;
    font-size: 14px !important;
    font-weight: 600;
  }
  .left-info {
    z-index: 3;
    color: #fff;
  }
  .left-content {
    max-width: 100%;
  }
  .slide-title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  .slide-text {
    font-size: 18px;
    opacity: 0.85;
  }
  .right-side {
    z-index: 3;
  }
  .login-card {
    width: 420px;
    background: #ffffff;
    border-radius: 18px;
  }
  .btn-login {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 15px;
    border-radius: 10px !important;
    background: #000 !important;
    border: none !important;
  }
  .divider {
    text-align: center;
    margin: 20px 0;
    position: relative;
  }
  .divider span {
    background: white;
    padding: 0 12px;
    font-size: 12px;
    color: #777;
  }
  .invalid-feedback {
    display: none !important;
  }
  .divider:before {
    content: "";
    height: 1px;
    background: #ddd;
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    z-index: 0;
  }
  .forgot-link,
  .register-link {
    font-weight: 400;
    font-size: 13px;
    color: #000 !important;
  }
  .register-link {
    text-decoration: underline;
  }
  .navbar {
    display: none;
  }
</style>
